<script>
    import LoadingIcon from "./LoadingIcon.svelte";
    import {unsetPrivateAnalyzeHandler, setPrivateAnalyzeHandler} from "../lib/ApiRequests.svelte";
    import {_} from '../lib/i18n';

    export let analyze;
    export let show = false;

    let isLoading = false;
    let isLoading2 = false;

    let handlerAccountId;
    $: handlerAccountId = (analyze && analyze.handler ? analyze.handler.id : '');

    async function addHandler() {
        isLoading = true;
        const setHandlerResponse = await setPrivateAnalyzeHandler(analyze.id, handlerAccountId);
        if (setHandlerResponse.status === 'ok') {
            analyze.is_not_friend = false;
            analyze.changeKeyValue('is_not_friend', false);
            analyze = analyze;
            show = false;
        }
        isLoading = false;
    }

    async function changeHandler() {
        isLoading2 = true;
        try {
            const result = await unsetPrivateAnalyzeHandler(handlerAccountId);
            if (result) {
                analyze.is_not_friend = false;
                analyze.handler = null;
                analyze.changeKeyValue('is_not_friend', false);
                analyze.changeKeyValue('handler', null);
                analyze = analyze;
                show = false;
            }
        } catch (err) {
            console.error(err);
        }
        isLoading2 = false;
    }

</script>

{#if show}
    <section class="system-info system-info_pink">
        <div class="not-friend-block__title-wrapper system-info__title-wrapper">
            <div class="private-acc-block__title-icon system-info__title-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <ellipse cx="10.0003" cy="14.1668" rx="0.833333" ry="0.833333" fill="#C93329"/>
                    <path d="M10 8.3335L10 11.6668" stroke="#C93329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M3.11421 14.6057L8.21147 4.4112C8.94852 2.93711 11.0521 2.93711 11.7892 4.4112L16.8864 14.6057C17.5513 15.9355 16.5844 17.5002 15.0976 17.5002H4.90306C3.4163 17.5002 2.4493 15.9355 3.11421 14.6057Z" stroke="#C93329" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <h3 class="not-friend-block__title-text system-info__title-text">
                {$_('notFriendAlert.title')}
            </h3>
        </div>
        <p class="private-acc-block__text system-info__text">
            {@html $_('notFriendAlert.description')}
        </p>

        <div class="private-acc-block__controls-wrapper system-info__controls-wrapper">
            <div class="button button_textual system-info__controls-btn_secondary
                private-acc-block__btn not-friend-oval-btn"
                 on:click={addHandler}>
                {$_('notFriendAlert.try')}
                <LoadingIcon show={isLoading} width="16" height="16"/>
            </div>
            <button class="button private-acc-block__form-btn not-friend-second-btn"
                    on:click={changeHandler}>
                {$_('notFriendAlert.change')}
                <LoadingIcon show={isLoading2} width="16" height="16"/>
            </button>
        </div>
    </section>
{/if}

<style>
    .system-info__title-icon svg path {
        stroke: #c93329;
    }
    .not-friend-oval-btn {
        border-radius: 12px;
        border: 1px solid var(--black-16161516, #161516);
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .not-friend-second-btn {
        text-align: center;
        background: unset;
        color: var(--color-black-16);
        width: 100%;
        padding-bottom: 0;
    }
    .system-info__controls-wrapper {
        margin-bottom: 0;
    }
</style>